import { isLoggedIn } from '../utils/UserSession';
import Storage from '../utils/StorageManager';

const managePersistentSessions = () => {
  if (!document.cookie.includes('WC_PERSISTENT')) {
    Storage.removeLocalStorage('PERSISTENT_SESSION');

    if (!isLoggedIn()) {
      Storage.setCookie('USERTYPE', 'G', 'session');
    }
  }
};
export default managePersistentSessions;
